import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/employee-templates')({
  staticData: { breadcrumb: 'Employee Templates', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEE_TEMPLATES' },
});
